import Swal from "sweetalert2";
import {defineComponent} from "vue";
import Loading from "@/components/Generic/Loading.vue";

export default defineComponent({
    components: {Loading}
})


let swal_delete
let swal_notification
let swal_info


/*
*
* MODAL DE CONFIRMACIÓN DE BORRADO
*  1º LLAMAR A initSweetAlert
*
*  2º LLAMAR A fireSweetAlert PARA MOSTRAR EL MODAL
*       PARAMS:
*           title (String): Titulo del modal
*           text (String): Texto que se muestra en el cuerpo del modal
*           confirm_function (Function): Función que se ejecuta al presionar
*                                        el botón de aceptar
*
* */
export function initSweetAlert() {
    swal_delete = Swal.mixin({
        customClass: {
            container: 'z-index-max',
            popup: 'card-modal body-modal',
            htmlContainer: 'personalize-scroll max-height-50',
            confirmButton: 'btn button-bg-primary-color',
            cancelButton: 'btn button-bg-white',
            actions: 'footer-modal',
            loader: 'custom-loader'
        },
        loaderHtml:
            `<div class="spinner-border text-primary" role="status">
            </div>`,
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'No, volver atrás',
        showLoaderOnConfirm: true,
    })
}

export async function fireSweetAlert(title, confirm_function, text = 'No podrás deshacer esta acción') {
    return swal_delete.fire({
        title,
        text,
        preConfirm: async () => {
            return await confirm_function()

        },
    })
}

export function initSweetNotification() {
    swal_notification = Swal.mixin({
        toast: true,
        position: "bottom-right",
        iconColor: 'white',
        customClass: {
            container: 'colored-toast',
            popup: 'colored-toast',
            htmlContainer: 'colored-toast',
        },
        showConfirmButton: false,
        timer: 6000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
}

export function getSweetNotification() {
    return swal_notification
}